import {Routes} from '@angular/router';
import {authenticatedGuard} from './guards/authenticated.guard';
import {dayTripDetailResolver} from './shell/day-trips/day-trip-detail.resolver';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./shell/shell').then(m => m.Shell),
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () => import('./shell/home/home').then(m => m.Home),
      },
      {
        path: 'signup',
        loadComponent: () => import('./shell/signup/signup').then(m => m.Signup)
      },
      {
        path: 'home',
        loadComponent: () => import('./shell/home/home').then(m => m.Home),
      },
      {
        path: 'events/:id',
        loadComponent: () => import('./shell/events/event-detail/event-detail').then(m => m.EventDetail),
      },
      {
        path: 'share/:token',
        loadComponent: () => import('./shell/share/share-resolver/share-resolver').then(m => m.ShareResolver),
      },
      {
        path: 'shared-schedule/:token',
        loadComponent: () => import('./shell/share/shared-scheduler/shared-scheduler').then(m => m.SharedScheduler),
      },
      {
        path: 'settings',
        loadComponent: () => import('./shell/settings/settings').then(m => m.Settings),
      },
      {
        path: 'profile',
        loadComponent: () => import('./shell/profile/profile').then(m => m.Profile),
      },
      {
        path: 'scheduler',
        canActivate: [authenticatedGuard],
        loadComponent: () => import('./shell/scheduler/scheduler').then(m => m.Scheduler),
      },
      {
        path: 'admin',
        canActivate: [authenticatedGuard],
        loadComponent: () => import('./shell/admin/admin-control-panel/admin-control-panel').then(m => m.AdminControlPanel),
      },
      {
        path: 'locations',
        loadComponent: () => import('./shell/locations/location-list/location-list').then(m => m.LocationList)
      },
      {
        path: 'locations/:id',
        loadComponent: () => import('./shell/locations/location-detail/location-detail').then(m => m.LocationDetail)
      },
      {
        path: 'playgrounds',
        loadComponent: () => import('./shell/playgrounds/playground-list/playground-list').then(m => m.PlaygroundList)
      },
      {
        path: 'playgrounds/new',
        canActivate: [authenticatedGuard],
        loadComponent: () => import('./shell/playgrounds/playground-submit/playground-submit').then(m => m.PlaygroundSubmit)
      },
      {
        path: 'playgroups/new',
        canActivate: [authenticatedGuard],
        loadComponent: () => import('./shell/playgroups/playgroup-submit/playgroup-submit').then(m => m.PlaygroupSubmit)
      },
      {
        path: 'playgroups/moderation',
        canActivate: [authenticatedGuard],
        loadComponent: () => import('./shell/playgroups/playgroup-moderation/playgroup-moderation').then(m => m.PlaygroupModeration)
      },
      {
        path: 'playgrounds/moderation',
        loadComponent: () => import('./shell/playgrounds/playground-moderation/playground-moderation').then(m => m.PlaygroundModeration)
      },
      {
        path: 'playgrounds/:id',
        loadComponent: () => import('./shell/playgrounds/playground-detail/playground-detail').then(m => m.PlaygroundDetail)
      },
      {
        path: 'day-trips',
        loadComponent: () => import('./shell/day-trips/day-trip-list').then(m => m.DayTripList)
      },
      {
        path: 'day-trips/new',
        canActivate: [authenticatedGuard],
        loadComponent: () => import('./shell/day-trips/day-trip-submit').then(m => m.DayTripSubmit)
      },
      {
        path: 'day-trips/edit/:id',
        canActivate: [authenticatedGuard],
        loadComponent: () => import('./shell/day-trips/day-trip-submit').then(m => m.DayTripSubmit)
      },
      {
        path: 'day-trips/moderation',
        canActivate: [authenticatedGuard],
        loadComponent: () => import('./shell/day-trips/day-trip-moderation').then(m => m.DayTripModeration)
      },
      {
        path: 'day-trips/:id',
        loadComponent: () => import('./shell/day-trips/day-trip-detail').then(m => m.DayTripDetail),
        resolve: {dayTrip: dayTripDetailResolver},
      },
      {
        path: '**',
        loadComponent: () => import('./shell/home/home').then(m => m.Home),
      }
    ]
  },
];
